export default "__VITE_ASSET__cb1d840d__"